import Model from './Model';

export default class Field extends Model {

    id = null;
    form = null;
    ordinal = 0;
    icon = null;
    title = '';
    type = 'text';
    required = false;
    options = [];

    constructor(data = {}) {
        super(data);
        Object.assign(this, data);
    }

    position() {
        if (this.type == 'boolean') {
            return undefined;
        }
        if (this.type == 'location') {
            return "fixed";
        }
        if (this.type == 'select' || this.type == 'multiple') {
            return undefined;
        }
        if (this.type == 'date' || this.type == 'time' || this.type == 'datetime') {
            return undefined;
        }
        return "floating";
    }

    static getIcon(type) {
        switch(type) {
          case 'text': return "list";
          case 'email': return "mail";
          case 'phone': return "call";
          case 'url': return "link";
          case 'number': return "stats";
          case 'boolean': return "checkmark-circle";
          case 'select': return "radio-button-on";
          case 'multiple': return "checkbox";
          case 'date': return "calendar";
          case 'time': return "time";
          case 'datetime': return "calendar";
          case 'image': return "image";
          case 'location': return "pin";
          case 'signature': return "create";
          case 'barcode': return "barcode";
          case 'qrcode': return "scanner";
          default: return "list";
        }
    }

}